import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';
import classnames from 'classnames';

// PropTypes
import { jobPropTypes } from '../../../../proptypes/jobProptypes';
import { companyPropTypes } from '../../../../proptypes/companyProptypes';

// Context
import ApproachContext from '../../../../context/ApproachContext';

// Components
import BenefitIcon from '../../../shared/BenefitIcon';

// Utils
import { langShorthand } from '../../../../utils';

// Styles
import styles from './benefitsSection.module.scss';

const cx = classnames.bind(styles);

const BenefitsSection = ({ job, company, companyColor }) => {
  const approach = useContext(ApproachContext);
  const { t } = useTranslation('common');

  const hasBenefitsSection =
    job.benefits_pool_selected?.length > 0 ||
    job.benefits_custom_selected?.length > 0;
  // job.extra_info?.additional_benefits;

  if (!hasBenefitsSection) return null;

  return (
    <section id="benefits-section" className={styles.container}>
      <h2 className={styles.heading}>
        {t(`description_page.benefits_section.title.${approach}`)}
      </h2>

      {(job.benefits_pool_selected?.length > 0 ||
        job.benefits_custom_selected?.length > 0) && (
        <div
          className={cx(styles.gridContainer, {
            // [styles.noAdditional]: !job.extra_info?.additional_benefits,
          })}
        >
          <>
            {job.benefits_pool_selected?.map((benefit_id) => {
              const benefit = company.benefits_pool?.find(
                (companyBenefit) => companyBenefit.id === benefit_id,
              );

              if (!benefit) return null;

              return (
                <div key={benefit_id} className={styles.cellContainer}>
                  <div className={styles.cell}>
                    <BenefitIcon
                      icon={benefit.icon}
                      wrapperClasses={styles.benefitIcon}
                      companyColour={companyColor}
                    />
                    <p className={styles.benefitName}>
                      {t(
                        `description_page.benefits_section.default_benefits.${benefit.id}.${approach}`,
                      )}
                    </p>
                  </div>
                </div>
              );
            })}
            {job.benefits_custom_selected?.map((benefit_id) => {
              const benefit = company.benefits_custom?.find(
                (companyBenefit) =>
                  companyBenefit.id === benefit_id && !companyBenefit.deleted,
              );
              if (
                !benefit ||
                !benefit.description?.find(
                  (description) =>
                    description.lang === langShorthand(job.job_language.mid),
                )?.content
              )
                return null;
              return (
                <div key={benefit_id} className={styles.cellContainer}>
                  <div className={styles.cell}>
                    <BenefitIcon
                      icon={benefit.icon}
                      wrapperClasses={styles.benefitIcon}
                      companyColour={companyColor}
                    />
                    <p className={styles.benefitName}>
                      {
                        benefit.description?.find(
                          (description) =>
                            description.lang ===
                            langShorthand(job.job_language.mid),
                        )?.content
                      }
                    </p>
                  </div>
                </div>
              );
            })}
          </>
        </div>
      )}

      {/* {job.extra_info?.additional_benefits && (
        <div
          className={cx(styles.additional, {
            [styles.hasBasicBenefits]:
              job.benefits_custom_selected?.length > 0 ||
              job.benefits_pool_selected?.length > 0,
          })}
        >
          {(job.benefits_custom_selected?.length > 0 ||
            job.benefits_pool_selected?.length > 0) && (
            <h3 className={styles.heading}>
              {t(
                `description_page.benefits_section.additional_benefits.${approach}`,
              )}
            </h3>
          )}
          <div
            className={`html-div ${styles.additionalContent}`}
            dangerouslySetInnerHTML={{
              __html: job.extra_info?.additional_benefits,
            }}
          />
        </div>
      )} */}
    </section>
  );
};

BenefitsSection.propTypes = {
  job: PropTypes.shape(jobPropTypes).isRequired,
  company: PropTypes.shape(companyPropTypes).isRequired,
  companyColor: PropTypes.string.isRequired,
};

export default BenefitsSection;
